import Reveal from '@/pages/zz-review/components/Reveal';

export default function NextBookSection() {
  return (
    <section id="next" className="w-full py-16 md:py-24 bg-background-100 scroll-mt-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <Reveal>
          <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500 border border-background-200/70 rounded-full px-3 py-1.5 mb-5">
            Coming Next
          </span>
          <h2
            className="text-2xl md:text-4xl text-foreground-900 mb-4"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            下一站：《一之門 Oneness Gate》
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
            《1001旋轉門》完成 1D–5D 的生命築基之後，《一之門》將繼續展開下一階段的生命實踐與文明道路。目前持續編寫與系統建構中。
          </p>
          <p className="text-xs text-foreground-400 mt-4">本階段不開放未完成功能。</p>
        </Reveal>
      </div>
    </section>
  );
}